// extracted by mini-css-extract-plugin
export default {"listingpageStyle":"listingPage_listingpageStyle__91XnA","modal":"listingPage_modal__2f0WH","modalMob":"listingPage_modalMob__hgd0j"};